<template>
  <div
    class="q-bottom-panel"
    :class="{isTransformed, isFixed, isBlockWindow}"
  >
    <div class="q-bottom-panel__top">
      <slot/>
    </div>
    <div class="q-bottom-panel__bottom" :class="`role-${$store.state.user.role}`">
      <div class="navigation" :class="{'center': $store.state.user.role !== 1}">

        <router-link
          v-if="$store.state.user.role === 4"
          to="/rfid"
          class="navigation__link q-bottom-panel-item-rfid"
        >
          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.42747 19.7556L5.42725 19.7559L5.43521 19.7626C5.6235 19.9224 5.86736 20.0066 6.1168 19.9996C6.36624 19.9926 6.60471 19.8948 6.78307 19.7245C6.96164 19.554 7.06647 19.3234 7.07399 19.0794C7.08151 18.8354 6.99104 18.5991 6.82305 18.4186L6.82328 18.4184L6.81579 18.4112C5.31225 16.9747 4.46896 15.0281 4.46896 13C4.46896 10.9719 5.31225 9.02534 6.81579 7.58878L6.816 7.58899L6.82305 7.58142C6.99104 7.40089 7.08151 7.16456 7.07399 6.92059C7.06647 6.67665 6.96164 6.44604 6.78307 6.27551C6.60471 6.10517 6.36624 6.00742 6.1168 6.00041C5.86736 5.99339 5.6235 6.07757 5.43521 6.23738L5.43501 6.23714L5.42747 6.24435C3.55379 8.03546 2.5 10.4652 2.5 13C2.5 15.5348 3.55379 17.9645 5.42747 19.7556ZM8.29292 17.2167L8.29256 17.2171L8.30302 17.2257C8.49205 17.3806 8.73416 17.4608 8.98083 17.4518C9.22752 17.4428 9.4628 17.3452 9.63924 17.1767C9.81586 17.008 9.92051 16.7805 9.93014 16.5393C9.93978 16.2981 9.85356 16.0633 9.69059 15.8819L9.69098 15.8816L9.68124 15.8723C8.8835 15.1102 8.43668 14.0782 8.43668 13.0036C8.43668 11.9311 8.8818 10.901 9.67669 10.1393C9.77758 10.0554 9.86006 9.95244 9.91874 9.83638C9.9785 9.7182 10.0122 9.58919 10.0175 9.45749C10.0227 9.32578 9.9994 9.1946 9.94918 9.07226C9.89897 8.94994 9.82304 8.83934 9.72655 8.74719C9.63007 8.65506 9.51511 8.58332 9.38905 8.53612C9.263 8.48893 9.12833 8.46718 8.99339 8.47209C8.85845 8.47701 8.72582 8.50849 8.60376 8.56478C8.48382 8.6201 8.37643 8.6983 8.2883 8.79496C7.1233 9.91118 6.46772 11.4244 6.46772 13.0036C6.46772 14.5849 7.12504 16.1001 8.29292 17.2167ZM9.7607 9.75767C9.71215 9.85369 9.64335 9.93909 9.55862 10.0085C8.72702 10.803 8.25986 11.8803 8.25986 13.0036C8.25986 14.127 8.72702 15.2043 9.55862 15.9987C9.69166 16.1468 9.76125 16.3374 9.75346 16.5324C9.74567 16.7273 9.66109 16.9123 9.51663 17.0502C9.37217 17.1882 9.17849 17.269 8.97435 17.2764L8.97404 17.2764C9.17819 17.269 9.37187 17.1882 9.51632 17.0503C9.66078 16.9123 9.74537 16.7273 9.75315 16.5324C9.76094 16.3374 9.69135 16.1468 9.55831 15.9987C8.72672 15.2043 8.25955 14.127 8.25955 13.0036C8.25955 11.8803 8.72672 10.803 9.55831 10.0085C9.64305 9.9391 9.71185 9.8537 9.7604 9.75768C9.80895 9.66166 9.83621 9.5571 9.84046 9.45054C9.84472 9.34399 9.82588 9.23775 9.78512 9.13848C9.74437 9.03921 9.68258 8.94904 9.60363 8.87365C9.52468 8.79825 9.43028 8.73924 9.32633 8.70032C9.23751 8.66706 9.14335 8.64908 9.04822 8.64709C9.14346 8.64905 9.23772 8.66702 9.32664 8.70031C9.43058 8.73923 9.52499 8.79824 9.60394 8.87364C9.68289 8.94904 9.74468 9.0392 9.78543 9.13847C9.82618 9.23774 9.84502 9.34399 9.84077 9.45054C9.83651 9.55709 9.80926 9.66165 9.7607 9.75767ZM6.89725 6.92596C6.89118 6.72885 6.80648 6.5414 6.66047 6.40196C6.51446 6.26252 6.31819 6.18162 6.11179 6.17582C6.09642 6.17539 6.08108 6.17538 6.06579 6.17578C6.08098 6.17539 6.09622 6.1754 6.11148 6.17583C6.31788 6.18163 6.51415 6.26253 6.66016 6.40197C6.80617 6.54141 6.89087 6.72885 6.89695 6.92597C6.90302 7.12308 6.83001 7.31496 6.69285 7.46236C5.15546 8.93127 4.29183 10.9231 4.29183 13C4.29183 15.0769 5.15546 17.0687 6.69285 18.5377C6.83001 18.6851 6.90302 18.8769 6.89695 19.074C6.89087 19.2712 6.80617 19.4586 6.66016 19.598C6.51415 19.7375 6.31788 19.8184 6.11148 19.8242L6.11179 19.8242C6.31819 19.8184 6.51446 19.7375 6.66047 19.598C6.80648 19.4586 6.89118 19.2712 6.89726 19.074C6.90333 18.8769 6.83032 18.685 6.69315 18.5376C5.15577 17.0687 4.29214 15.0769 4.29214 13C4.29214 10.9231 5.15577 8.93126 6.69315 7.46235C6.83032 7.31495 6.90333 7.12307 6.89725 6.92596ZM19.5648 19.7626L19.565 19.7629L19.5725 19.7556C21.4462 17.9645 22.5 15.5348 22.5 13C22.5 10.4652 21.4462 8.03546 19.5725 6.24435L19.5727 6.24413L19.5648 6.23738C19.3765 6.07757 19.1326 5.99339 18.8832 6.00041C18.6338 6.00742 18.3953 6.10517 18.2169 6.27551C18.0384 6.44604 17.9335 6.67665 17.926 6.92059C17.9185 7.16456 18.009 7.40089 18.1769 7.58142L18.1767 7.58162L18.1842 7.58878C19.6877 9.02534 20.531 10.9719 20.531 13C20.531 15.0281 19.6877 16.9747 18.1842 18.4112L18.184 18.411L18.1769 18.4186C18.009 18.5991 17.9185 18.8354 17.926 19.0794C17.9335 19.3234 18.0384 19.554 18.2169 19.7245C18.3953 19.8948 18.6338 19.9926 18.8832 19.9996C19.1326 20.0066 19.3765 19.9224 19.5648 19.7626ZM16.7354 17.2257L16.7357 17.2261L16.7454 17.2167C17.9133 16.1001 18.5706 14.5849 18.5706 13.0036C18.5706 11.4244 17.9151 9.91117 16.7501 8.79496C16.6619 8.69829 16.5545 8.62009 16.4346 8.56478C16.3126 8.50849 16.1799 8.47701 16.045 8.47209C15.91 8.46718 15.7754 8.48892 15.6493 8.53612C15.5233 8.58332 15.4083 8.65505 15.3118 8.74719C15.2153 8.83934 15.1394 8.94994 15.0892 9.07225C15.039 9.19459 15.0157 9.32577 15.0209 9.45748C15.0262 9.58919 15.0599 9.7182 15.1196 9.83638C15.1783 9.95244 15.2608 10.0554 15.3617 10.1393C16.1566 10.901 16.6017 11.9311 16.6017 13.0036C16.6017 14.0782 16.1549 15.1102 15.3571 15.8723L15.3568 15.8719L15.3478 15.8819C15.1848 16.0633 15.0986 16.2981 15.1082 16.5393C15.1179 16.7805 15.2225 17.008 15.3991 17.1767C15.5756 17.3452 15.8109 17.4428 16.0575 17.4518C16.3042 17.4608 16.5463 17.3806 16.7354 17.2257ZM16.3601 8.72392C16.4606 8.77029 16.5501 8.836 16.6228 8.91692C17.7568 10.0012 18.3938 11.4711 18.3938 13.0036C18.3938 14.5362 17.7568 16.0061 16.6228 17.0903C16.4804 17.207 16.3005 17.2726 16.114 17.2768C16.3004 17.2725 16.4802 17.207 16.6225 17.0904C17.7565 16.0061 18.3935 14.5362 18.3935 13.0036C18.3935 11.4711 17.7565 10.0012 16.6225 8.91692C16.5498 8.836 16.4603 8.7703 16.3598 8.72393C16.2592 8.67756 16.1498 8.65153 16.0382 8.64747C16.0217 8.64687 16.0052 8.64675 15.9887 8.64711C16.0053 8.64674 16.0219 8.64685 16.0385 8.64746C16.1501 8.65152 16.2596 8.67756 16.3601 8.72392ZM19.0024 6.18032C19.1677 6.19804 19.3242 6.26409 19.4499 6.37074C21.2897 8.12951 22.3232 10.5139 22.3232 13C22.3232 15.4861 21.2897 17.8705 19.4499 19.6293C19.3057 19.7516 19.121 19.8205 18.9291 19.8243C19.1209 19.8204 19.3055 19.7515 19.4496 19.6293C21.2894 17.8705 22.3229 15.4861 22.3229 13C22.3229 10.5139 21.2894 8.12952 19.4496 6.37075C19.324 6.26416 19.1675 6.1981 19.0024 6.18032ZM14.4646 13C14.4646 11.9231 13.5849 11.0501 12.4999 11.0501C12.4862 11.0501 12.4725 11.0503 12.4588 11.0506C12.4726 11.0503 12.4864 11.0501 12.5002 11.0501C13.5852 11.0501 14.4649 11.9231 14.4649 13C14.4649 14.0473 13.6329 14.9017 12.5892 14.9479C13.6328 14.9016 14.4646 14.0472 14.4646 13ZM14.6417 13C14.6417 11.8262 13.6829 10.8747 12.5002 10.8747C11.3175 10.8747 10.3587 11.8262 10.3587 13C10.3587 14.1738 11.3175 15.1253 12.5002 15.1253C13.6829 15.1253 14.6417 14.1738 14.6417 13Z" fill="white"/>
          </svg>
          <span>RFID</span>
        </router-link>

        <template v-if="$store.state.user.role === 1">
          <router-link to="/analytics" class="navigation__link q-bottom-panel-item-analytics" >
            <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22.0975 3.44024C22.3405 2.94429 22.1354 2.34525 21.6395 2.10223C21.1435 1.85922 20.5445 2.06426 20.3015 2.56021L18.1248 7.00247L17.1937 6.04957C16.1919 5.02424 14.4684 5.35482 13.917 6.67807L12.2764 10.6156C12.064 11.1254 12.3051 11.7109 12.8149 11.9233C13.3247 12.1357 13.9101 11.8946 14.1226 11.3848L15.7632 7.4473L16.6943 8.4002C17.6599 9.38845 19.3128 9.12323 19.9208 7.8825L22.0975 3.44024Z" fill="white"/>
              <path d="M6.19922 2C7.30379 2 8.19922 2.89543 8.19922 4V20C8.19922 21.1046 7.30379 22 6.19922 22H4.19922C3.09465 22 2.19922 21.1046 2.19922 20V4C2.19922 2.89543 3.09465 2 4.19922 2H6.19922Z" fill="white"/>
              <path d="M20.1992 16C21.3038 16 22.1992 16.8954 22.1992 18V20C22.1992 21.1046 21.3038 22 20.1992 22H14.1992C13.0946 22 12.1992 21.1046 12.1992 20V18C12.1992 16.8954 13.0946 16 14.1992 16H20.1992Z" fill="white"/>
            </svg>
            <span>Аналитика</span>
          </router-link>
        </template>

        <div v-if="$store.state.user.role === 6" class="docs-client q-bottom-panel-item-docs">
          <div
            class="navigation__link docs"
            :class="{'router-link-active router-link-exact-active' : $route.path === '/orders' || $route.path === '/acts'}"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.00028 18.5723V5.42941C4.00028 3.22027 5.79114 1.42941 8.00028 1.42941H13.9731C15.0787 1.42941 16.1351 1.88704 16.8912 2.69364L19.7756 5.77025C20.4706 6.51164 20.8574 7.48978 20.8574 8.50602V18.5723C20.8574 20.7814 19.0666 22.5723 16.8574 22.5723H8.00028C5.79114 22.5723 4.00028 20.7814 4.00028 18.5723ZM12.0006 15.8579C12.0006 17.0414 11.0412 18.0008 9.8577 18.0008C8.67423 18.0008 7.71484 17.0414 7.71484 15.8579C7.71484 14.6744 8.67423 13.7151 9.8577 13.7151C11.0412 13.7151 12.0006 14.6744 12.0006 15.8579ZM8.57161 9.4517C8.11138 9.4517 7.73828 9.8248 7.73828 10.285C7.73828 10.7453 8.11138 11.1184 8.57161 11.1184H16.2859C16.7461 11.1184 17.1192 10.7453 17.1192 10.285C17.1192 9.8248 16.7461 9.4517 16.2859 9.4517H8.57161Z" fill="white"/>
            </svg>
            <span>Документы</span>
            <svg class="docs__arrow" width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.83594 13.418L13.7343 16.8291C14.1742 17.214 14.831 17.214 15.2709 16.8291L19.1693 13.418" stroke="#C6C6C6" stroke-width="2.5" stroke-linecap="round"/>
            </svg>
          </div>
          <div class="docs__panel">
            <ul class="content">
              <li @click="goFromDocs('/acts')">Акты</li>
              <li @click="goFromDocs('/orders')">Заявки</li>
            </ul>
          </div>
        </div>

        <router-link to="/acts" class="navigation__link q-bottom-panel-item-acts" v-if="$store.state.user.role !== 6 && $store.state.user.role !== 4">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.00028 18.5723V5.42941C4.00028 3.22027 5.79114 1.42941 8.00028 1.42941H13.9731C15.0787 1.42941 16.1351 1.88704 16.8912 2.69364L19.7756 5.77025C20.4706 6.51164 20.8574 7.48978 20.8574 8.50602V18.5723C20.8574 20.7814 19.0666 22.5723 16.8574 22.5723H8.00028C5.79114 22.5723 4.00028 20.7814 4.00028 18.5723ZM12.0006 15.8579C12.0006 17.0414 11.0412 18.0008 9.8577 18.0008C8.67423 18.0008 7.71484 17.0414 7.71484 15.8579C7.71484 14.6744 8.67423 13.7151 9.8577 13.7151C11.0412 13.7151 12.0006 14.6744 12.0006 15.8579ZM8.57161 9.4517C8.11138 9.4517 7.73828 9.8248 7.73828 10.285C7.73828 10.7453 8.11138 11.1184 8.57161 11.1184H16.2859C16.7461 11.1184 17.1192 10.7453 17.1192 10.285C17.1192 9.8248 16.7461 9.4517 16.2859 9.4517H8.57161Z" fill="white"/>
          </svg>
          <span>Акты</span>
        </router-link>

        <router-link to="/counterparties" class="navigation__link q-bottom-panel-item-counterparties" >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1C5.92486 1 1 5.92488 1 12C1 18.0751 5.92486 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92488 18.0751 1 12 1ZM7.44145 13C6.76816 13 6.13484 13.291 5.71832 13.7816C5.28732 14.2892 5.09513 15.014 5.36405 15.7488C6.31579 18.3496 8.89687 20 11.9998 20C15.101 20 17.6172 18.3577 18.598 15.7883C18.8794 15.0509 18.6948 14.3166 18.2646 13.7997C17.8485 13.2996 17.209 13 16.5252 13L7.44145 13ZM8.99975 8C8.99975 6.34315 10.3429 5 11.9998 5C13.6566 5 14.9998 6.34315 14.9998 8C14.9998 9.65685 13.6566 11 11.9998 11C10.3429 11 8.99975 9.65685 8.99975 8Z" fill="white"/>
          </svg>
          <span>Контрагенты</span>
        </router-link>

        <router-link to="/districts" class="navigation__link q-bottom-panel-item-districts" v-if="$store.state.user.role === 1 && $store.state.user.role !== 4">
          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.8999 2C7.13848 2 4.8999 4.23858 4.8999 7V13C4.8999 15.7614 7.13848 18 9.8999 18H11.8999V21C11.8999 21.5523 12.3476 22 12.8999 22C13.4522 22 13.8999 21.5523 13.8999 21V18H15.8999C18.6613 18 20.8999 15.7614 20.8999 13V7C20.8999 4.23858 18.6613 2 15.8999 2H9.8999ZM12.8999 7C11.243 7 9.8999 8.34315 9.8999 10C9.8999 11.6569 11.243 13 12.8999 13C14.5568 13 15.8999 11.6569 15.8999 10C15.8999 8.34315 14.5568 7 12.8999 7Z" fill="white"/>
          </svg>
          <span>Районы</span>
        </router-link>

        <router-link to="/transport" class="navigation__link q-bottom-panel-item-transport" v-if="$store.state.user.role !== 4">
          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.89737 19.8572V21.3333C7.89737 21.7015 7.59889 22 7.2307 22H4.56404C4.19585 22 3.89737 21.7015 3.89737 21.3333V19.6791C3.71888 19.5554 3.58093 19.3739 3.51271 19.1561C2.73302 16.6666 2.29886 12.8622 2.52945 10.2166L2.83334 4.21533C2.89619 2.97412 3.92089 2 5.16368 2H20.638C21.8741 2 22.8958 2.96401 22.9674 4.19804L23.3168 10.2129C23.5481 12.8585 23.1143 16.6654 22.3342 19.1561C22.2595 19.3947 22.1011 19.5897 21.8974 19.7129V21.3333C21.8974 21.7015 21.5989 22 21.2307 22H18.564C18.1958 22 17.8974 21.7015 17.8974 21.3333V19.8572H7.89737ZM21.2596 9.28571L20.9708 4.31401C20.9606 4.13771 20.8146 4 20.638 4H5.16368C4.98614 4 4.83976 4.13916 4.83078 4.31647L4.57915 9.28571H21.2596ZM6.39746 16C7.22589 16 7.89746 15.3284 7.89746 14.5C7.89746 13.6716 7.22589 13 6.39746 13C5.56903 13 4.89746 13.6716 4.89746 14.5C4.89746 15.3284 5.56903 16 6.39746 16ZM20.8975 14.5C20.8975 15.3284 20.2259 16 19.3975 16C18.569 16 17.8975 15.3284 17.8975 14.5C17.8975 13.6716 18.569 13 19.3975 13C20.2259 13 20.8975 13.6716 20.8975 14.5ZM9.39746 14C9.12132 14 8.89746 14.2239 8.89746 14.5V15.6096C8.89746 15.839 9.05361 16.039 9.27619 16.0947L11.4422 16.6362C12.3977 16.8751 13.3972 16.8751 14.3527 16.6362L16.5187 16.0947C16.7413 16.039 16.8975 15.839 16.8975 15.6096V14.5C16.8975 14.2239 16.6736 14 16.3975 14H9.39746Z" fill="white"/>
          </svg>
          <span>Транспорт</span>
        </router-link>

        <router-link to="/kpp" class="navigation__link q-bottom-panel-item-transport" v-if="$store.state.user.role == 2">
          <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5 4.07667C14.5 2.62804 13.1053 1.62533 11.7978 2.13398L5.79775 4.46812C5.01714 4.7718 4.5 5.54595 4.5 6.41082V18.3681C4.5 19.3201 5.1246 20.15 6.01493 20.3809L12.0149 21.937C13.2772 22.2644 14.5 21.274 14.5 19.9242V15.1322V4.07667ZM15.5 4.6545C15.5 4.08156 15.9477 3.6171 16.5 3.6171H18.5C19.6046 3.6171 20.5 4.54602 20.5 5.6919V14.4176V18.1407C20.5 19.2865 19.6046 20.2155 18.5 20.2155H16.5C15.9477 20.2155 15.5 19.751 15.5 19.1781C15.5 18.6051 15.9477 18.1407 16.5 18.1407H18.5V14.4176V5.6919H16.5C15.9477 5.6919 15.5 5.22744 15.5 4.6545ZM10.5 10.8789C9.94772 10.8789 9.5 11.3434 9.5 11.9163C9.5 12.4892 9.94772 12.9537 10.5 12.9537C11.0523 12.9537 11.5 12.4892 11.5 11.9163C11.5 11.3434 11.0523 10.8789 10.5 10.8789Z" fill="white"/>
          </svg>
          <span>КПП</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, ref, onMounted, onBeforeUnmount, watchEffect, computed } from 'vue'
import store from '@/store'
import { useRouter } from 'vue-router'

const router = useRouter()

const props = defineProps({
  isFixed: {
    type: Boolean,
    default: false,
  }
})

const scrollY = ref(0)
const isTransformed = ref(false)
const getScrollY = () => {
  scrollY.value = window.pageYOffset
}
onMounted(()=> window.addEventListener("scroll", getScrollY))
onBeforeUnmount(()=> window.removeEventListener("scroll", getScrollY))
watchEffect(() => scrollY.value > 85 ? isTransformed.value = true : isTransformed.value = false)

const isBlockWindow = computed(()=> store.state.isBlockWindow)

const goFromDocs = url => {
  router.push(url)
}
</script>

<style scoped lang="scss">
.q-bottom-panel{
  position: fixed;
  z-index: 11;
  bottom: 0;
  left: calc(50% - 0px);
  transform: translateX(-50%);
  width: 1200px;
  height: 146px;
  background-color: $ford-medium-dark;
  border-radius: 24px 24px 0px 0px;
  transition: bottom ease-out .2s;
  &.isTransformed{
    bottom: -62px;
  }
  &.isFixed{
    bottom: -77px;
    .q-bottom-panel__bottom{
      bottom: 88px;
    }
    &:hover{
      bottom: -77px;
    }
  }
  &.isBlockWindow{
    bottom: 0;
    left: calc(50% - 2.5px);
  }
  &__bottom{
    position: absolute;
    bottom: 12px;
    left: 50%;
    transform: translateX(-50%);
  }
  &:hover{
    bottom: 0;
  }
}

.navigation{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1060px;
  &__link{
    display: flex;
    align-items: center;
    padding: 10px 24px;
    border-radius: 14px;
    text-decoration: none;
    transition: ease .3s;
    height: 48px;
    svg{
      margin-right: 15px;
    }
    span{
      color: white;
      font-size: 16px;
    }
    &:hover{
      background-color: rgba($white, 0.05);
    }
  }

  .router-link-active,
  .router-link-exact-active{
    background-color: rgba($white, 0.05);
    svg{
      path{
        fill: $lemon-lime;
      }
      &:last-child{
        path{
          fill: transparent;
        }
      }
    }
  }
}

.center{
  width: 870px;
}

.docs-client{
  position: relative;

  &:hover{
    .docs__panel{
      // opacity: 1;
      // visibility: visible;
      // transform: translateY(0px);
      display: block;
    }
    .docs__arrow{
      transform: rotate(180deg);
    }
  }
}

.docs{
  cursor: pointer;
  &__arrow{
    margin-left: 16px;
    margin-right: 0 !important;
    transition: ease .3s;
  }

  &__panel{
    position: absolute;
    right: 0;
    bottom: 46px;
    display: none;
    padding-bottom: 10px;

    .content{
      background-color: $ford-medium-dark;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
      border-radius: 22px;
      width: 160px;
      padding: 16px 8px;
      display: flex;
      flex-direction: column;
      gap: 2px 0;
    }

    li{
      padding: 8px 10px;
      font-size: 16px;
      line-height: 22px;
      color: white;
      border-radius: 14px;
      transition: ease .3s;
      cursor: pointer;
      &:last-child{
        margin-bottom: 0px;
      }
      &:hover{
        background: rgba(85, 85, 85, 0.6);
      }
    }
  }
}
</style>